"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _isHexColorValue = _interopRequireDefault(require("../../is-hex-color-value"));

var _getValidObject = _interopRequireDefault(require("../../get-valid-object"));

var DEFAULT_ON_CLICK_HANDLER = function DEFAULT_ON_CLICK_HANDLER() {};

var DEFAULT_X_AXIS_LABEL_STEP = null;
var DEFAULT_X_AXIS_LABEL_FORMATTER = undefined;
var DEFAULT_X_AXIS_TICK_LENGTH = 4;
var DEFAULT_X_AXIS_TICK_WIDTH = 1;
/**
 * @callback MwChartTwoYAxisLabelFormatter
 *
 * Custom behavior to format the label for a particular mark on the x-axis.
 *
 * @param {AxisLabelFormatterOptions} options Options provided by the chart
 * @returns {string} Text to show as the x-axis label
 */

/**
 * A class to represent the visualization options for a Two Y Axis Line Chart
 * @param {object} options options object (See below)
 * @param {boolean} [options.animate=true] Dictate whether to animate the chart when rendering (True=yes, false=no)
 * @param {boolean} [options.areDataLabelsVisible=false] Dictate whether to show labels on the points of the chart (True=yes, false=no)
 * @param {string} options.leftYAxisLineColor A hex color value for the left y-axis (Eg #ffbbcc)
 * @param {function} [options.onError] A function to handle an error when rendering
 * @param {function} [options.onPointClick] A function to be passed a point data object (ie key, keyIndex, seriesName, value) on click
 * @param {string} options.rightYAxisLineColor A hex color value for the left y-axis (Eg #ffbbcc)
 * @param {function} options.tooltipFormatter A function that should return String to display as the tooltip.  It will be passed a MwChartTwoYAxisLineTooltipOptions object when invoked.
 * @param {MwChartTwoYAxisLabelFormatter} [options.xAxisLabelFormatter] A function that should return a string to display labels on the x-axis. It will be passed an AxisLabelFormatterOptions object when invoked.
 * @param {number} [options.xAxisLabelStep] Indicates how often to display a label on the x-axis. (Eg 1 will display all labels. 2 will every other. 3 every third.)
 * @param {number} [options.xAxisTickLength=4] The length of the tick mark to be displayed on the x-axis (in px)
 * @param {number} [options.xAxisTickWidth=1] The width of the tick mark to be displayed on the x-axis (in px)
 */

var MwChartTwoYAxisLineChartOptions = function MwChartTwoYAxisLineChartOptions(options) {
  (0, _classCallCheck2.default)(this, MwChartTwoYAxisLineChartOptions);
  var safeOptions = (0, _getValidObject.default)(options);

  if (!safeOptions.leftYAxisLineColor) {
    safeOptions.leftYAxisLineColor = '#ffad00';
  } else if (!(0, _isHexColorValue.default)(safeOptions.leftYAxisLineColor)) {
    throw new TypeError("options.leftYAxisLineColor must be a valid hex color value. Provided value: ".concat(safeOptions.leftYAxisLineColor));
  }

  if (typeof safeOptions.onError !== 'function' && safeOptions.onError !== undefined) {
    throw new TypeError("options.onError must be a function. Provided value: ".concat(safeOptions.onError));
  }

  if (safeOptions.onPointClick === undefined) {
    safeOptions.onPointClick = DEFAULT_ON_CLICK_HANDLER;
  } else if (typeof safeOptions.onPointClick !== 'function' && safeOptions.onPointClick !== undefined) {
    throw new TypeError("options.onPointClick must be a function. Provided value: ".concat(safeOptions.onPointClick));
  }

  if (!safeOptions.rightYAxisLineColor) {
    safeOptions.rightYAxisLineColor = '#3399ff';
  } else if (!(0, _isHexColorValue.default)(safeOptions.rightYAxisLineColor)) {
    throw new TypeError("options.rightYAxisLineColor must be a valid hex color value. Provided value: ".concat(safeOptions.rightYAxisLineColor));
  }

  if (typeof safeOptions.tooltipFormatter !== 'function') {
    throw new TypeError("options.tooltipFormatter must be a function. Provided value: ".concat(safeOptions.tooltipFormatter));
  }

  var safeXAxisLabelFormatter = safeOptions.xAxisLabelFormatter;

  if (safeOptions.xAxisLabelFormatter === undefined) {
    safeXAxisLabelFormatter = DEFAULT_X_AXIS_LABEL_FORMATTER;
  } else if (typeof safeOptions.xAxisLabelFormatter !== 'function') {
    throw new TypeError("options.xAxisLabelFormatter must be a function. Provided value: ".concat(safeOptions.xAxisLabelFormatter));
  }

  var safeXAxisLabelStep = safeOptions.xAxisLabelStep;

  if (safeOptions.xAxisLabelStep === undefined || safeOptions.xAxisLabelStep === null) {
    safeXAxisLabelStep = DEFAULT_X_AXIS_LABEL_STEP;
  } else if (typeof safeOptions.xAxisLabelStep !== 'number') {
    throw new TypeError("options.xAxisLabelStep must be a number. Provided value: ".concat(safeOptions.xAxisLabelStep));
  }

  var safeXAxisLabelTickLength = safeOptions.xAxisTickLength;

  if (safeOptions.xAxisTickLength === undefined) {
    safeXAxisLabelTickLength = DEFAULT_X_AXIS_TICK_LENGTH;
  } else if (typeof safeOptions.xAxisTickLength !== 'number') {
    throw new TypeError("options.xAxisTickLength must be a number. Provided value: ".concat(safeOptions.xAxisTickLength));
  }

  var safeXAxisLabelTickWidth = safeOptions.xAxisTickWidth;

  if (safeOptions.xAxisTickWidth === undefined) {
    safeXAxisLabelTickWidth = DEFAULT_X_AXIS_TICK_WIDTH;
  } else if (typeof safeOptions.xAxisTickWidth !== 'number') {
    throw new TypeError("options.xAxisTickWidth must be a number. Provided value: ".concat(safeOptions.xAxisTickWidth));
  }

  this.animate = safeOptions.animate !== false;
  this.areDataLabelsVisible = Boolean(safeOptions.areDataLabelsVisible);
  this.leftYAxisLineColor = safeOptions.leftYAxisLineColor;
  this.onError = safeOptions.onError;
  this.onPointClick = safeOptions.onPointClick;
  this.rightYAxisLineColor = safeOptions.rightYAxisLineColor;
  this.tooltipFormatter = safeOptions.tooltipFormatter;
  this.xAxisLabelFormatter = safeXAxisLabelFormatter;
  this.xAxisLabelStep = safeXAxisLabelStep;
  this.xAxisTickLength = safeXAxisLabelTickLength;
  this.xAxisTickWidth = safeXAxisLabelTickWidth;
  Object.freeze(this);
};

exports.default = MwChartTwoYAxisLineChartOptions;